import { render, staticRenderFns } from "./NewsEvents.vue?vue&type=template&id=56cb2362&scoped=true&"
import script from "./NewsEvents.vue?vue&type=script&lang=js&"
export * from "./NewsEvents.vue?vue&type=script&lang=js&"
import style0 from "./NewsEvents.vue?vue&type=style&index=0&id=56cb2362&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56cb2362",
  null
  
)

export default component.exports